import { render, staticRenderFns } from "./ex-company-list.vue?vue&type=template&id=84bb5236&scoped=true&"
import script from "./ex-company-list.vue?vue&type=script&lang=js&"
export * from "./ex-company-list.vue?vue&type=script&lang=js&"
import style0 from "./ex-company-list.vue?vue&type=style&index=0&id=84bb5236&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84bb5236",
  null
  
)

export default component.exports